import React, { Fragment } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import CookiesPolicy from "../buttons/CookiesPolitics";
import "./footerMain.css";

const FooterMain = () => {
    const { t } = useTranslation();

    return (
        <Fragment>
            <footer id="footerMain">
                <Container className="py-3 text-center">
                    <Row>
                        <Col>© 2024 Pole Therapy by Weronika Kozanecka.</Col>
                    </Row>
                    <Row className="p-3 p-lg-2">
                        <Col>
                            <a href="/files/Regulamin-PT-2025.pdf" target="_blank" className="btn btn-link">
                                {t("studioRegulations")}
                            </a>
                        </Col>
                        <Col>
                            <a href="/files/Pole_Therapy_polityka_prywatności.pdf" target="_blank" className="btn btn-link">
                                {t("privacyPolicy")}
                            </a>
                        </Col>
                        <Col>
                            <CookiesPolicy />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="text-end">{t("websiteMadeBy")} Paszko.IT</Col>
                    </Row>
                </Container>
            </footer>
        </Fragment>
    );
};

export default FooterMain;
